// const ApiConfig = require('../../api.config.json')
// const host = process.argv[2];
import util from "zmfront-framework/src/utils/util";

var global_callback = null;
var global_callback2 = null;
var websock = null;
let pagetype = null;
const ws = {};

ws.reLinkWebSocket = function(){
    if(websock){
        return;
    }
    /*  //ws地址
      let dizhi = 'localhost';
      if(host){
          dizhi = host.split("=")[1];
      }

      dizhi = dizhi ? dizhi : 'localhost';*/

    let wsuri = process.env.WS_URL();
    let sysType = util.get('sysType')
    if (sysType && 'oms' == sysType){
        wsuri = process.env.OMS_WS_URL();
    }
    console.log('wsuri:'+wsuri)
    websock = new WebSocket(wsuri);
    websock.onmessage = function (e) {
        websocketonmessage(e);
    }
    websock.onclose = function (e) {
        websocketclose(e);
    }
    websock.onopen = function () {
        websocketOpen();
    }
    //连接发生错误的回调方法
    websock.onerror = function () {
        console.log("WebSocket连接发生错误");
    }
}

ws.initWebSocket = function() { //初始化weosocket
    global_callback = null;
    ws.reLinkWebSocket()
    /*if(websock){
        return;
    }
  /!*  //ws地址
    let dizhi = 'localhost';
    if(host){
        dizhi = host.split("=")[1];
    }

    dizhi = dizhi ? dizhi : 'localhost';*!/

    let wsuri = process.env.WS_URL();
    let sysType = util.get('sysType')
    if (sysType && 'oms' == sysType){
        wsuri = process.env.OMS_WS_URL();
    }
    console.log('wsuri:'+wsuri)
    websock = new WebSocket(wsuri);
    websock.onmessage = function (e) {
        websocketonmessage(e);
    }
    websock.onclose = function (e) {
        websocketclose(e);
    }
    websock.onopen = function () {
        websocketOpen();
    }
    //连接发生错误的回调方法
    websock.onerror = function () {
        console.log("WebSocket连接发生错误");
    }*/
}
// 实际调用的方法
ws.sendSock = function(agentData, callback, pageTypetemp) {
    pagetype = pageTypetemp
    if(pageTypetemp){
        global_callback2 = callback
    }else{
        global_callback = callback;
    }

    if (websock.readyState === websock.OPEN) {
        //若是ws开启状态
        websocketsend(agentData)
    } else if (websock.readyState === websock.CONNECTING) {
        // 若是 正在开启状态，则等待1s后重新调用
        setTimeout(function () {
            ws.sendSock(agentData, callback);
        }, 1000);
    } else {
        // 若未开启 ，则等待1s后重新调用
        setTimeout(function () {
            ws.sendSock(agentData, callback);
        }, 1000);
    }
}
//数据接收
function websocketonmessage(e) {
    if(pagetype){
        if(global_callback2!=null&&global_callback2!=""&&global_callback2!=undefined){
            global_callback2(JSON.parse(e.data));
        }

    }else{
        if(global_callback!=null&&global_callback!=""&&global_callback!=undefined){
            global_callback(JSON.parse(e.data));
        }

    }

    // return JSON.parse(e.data);
}

//数据发送
function websocketsend(agentData) {
    websock.send(JSON.stringify(agentData));
}
//关闭
function websocketclose(e) {
    websock = '';
    global_callback('1')
    console.log("connection closed (" + e.code + ")");
}
function websocketOpen(e) {
    if(global_callback){
        global_callback('2')
    }

    console.log("连接成功");
    // heartbeat();
    // login();
}
// initWebSocket();
export default ws;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/socked.js